import { SurveyComponent } from "@tree-company/tree-query";
import { survey } from "./survey";
import translate from "./locales";
import Footer from "./components/footer";

export default function App() {
  return (
    <div className="app">
      <title>{translate("app.title")}</title>
      <SurveyComponent survey={survey} />
      <Footer />
    </div>
  );
}
